<template>
    <div
        ref="card"
        class="private-card-card"
        :style="{
            transform: `perspective(1000px) rotate3d(1, 0, 0, ${15*(cardPerspective.y)}deg) rotate3d(0, 1, 0, ${15*cardPerspective.x}deg)`,
        }"
    >
    </div>
</template>
<script>
import { useMouse } from '../../assets/js/vue/utlis/useMouse';
import { useTouch } from '../../assets/js/vue/utlis/useTouch';
import { watch, reactive, ref, computed, } from 'vue';
import { useIntersectionObserver } from '../../assets/js/vue/utlis/useIntersectionObserver';
import { useStore } from '../../store';

export default {
    name: 'PrivateCardCard',
    setup() {
        const store = useStore();
        const isMobile = computed(() => store.state.app.isMobile);
        const innerWidth = computed(() => store.state.app.windowWidth);
        const windowHeight = computed(() => store.state.app.windowHeight);
        const card = ref(null);
        const sensitivity = 2.7; // force of following card by mouse

        const cardPerspective = reactive({
            x: 0,
            y: 0,
        });

        const cardIsVisible = ref(false);
        useIntersectionObserver(
            card,
            ([{ isIntersecting }]) => {
                cardIsVisible.value = isIntersecting;
            },
        );

        const mousePosX = ref(0);
        const mousePosY = ref(0);

        const mousePos = useMouse();
        const touchDelta = useTouch(card, { prevent: true });

        const touchStart = {
            x: innerWidth.value / 2,
            y: windowHeight.value / 2,
        };

        watch(touchDelta.isDown, (isDown) => {
            if (!isDown) return;

            touchStart.x = mousePosX.value;
            touchStart.y = mousePosY.value;
        }, { immediate: true });

        const touchSensitivity = 2.5;
        watch([isMobile, touchDelta.isDown, touchDelta.xDelta, touchDelta.yDelta], ([isMobile, isDown, xDelta, yDelta]) => {
            if (isMobile) {
                if (isDown) {
                    mousePosX.value = Math.min(innerWidth.value, Math.max(0, touchStart.x + xDelta*touchSensitivity));
                    mousePosY.value = Math.min(windowHeight.value, Math.max(0, touchStart.y + yDelta*touchSensitivity));
                }
            }
        }, { immediate: true });

        watch([isMobile, mousePos.x, mousePos.y], ([isMobile, x, y]) => {
            if (!isMobile) {
                mousePosX.value = x;
                mousePosY.value = y;
            }
        }, { immediate: true });

        watch([mousePosX, mousePosY], ([ x, y ]) => {
            if (!cardIsVisible.value) return;

            cardPerspective.x = (x / innerWidth.value - .5) * sensitivity;
            cardPerspective.y = -(y / windowHeight.value - .5) * sensitivity;
        }, { immediate: true });

        const cardCardK = computed(() => {
            return (cardPerspective.x + cardPerspective.y) / (isMobile.value ? 3 : 1);
        });

        watch(cardCardK, (k) => {
            const el = card.value;
            if (el) el.style.setProperty('--private-card-card-k', k);
        });

        return {
            card,
            cardPerspective,
            mousePosX,
            mousePosY,
        };
    },
};
</script>
<style lang="scss">
.private-card-card {
    width: 100%;
    height: 100%;
    --private-card-card-k: .5;

    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    background-blend-mode: color, soft-light;
    background-image: radial-gradient(at 0% 20%, rgba(255,163,96,.5) calc(var(--private-card-card-k) * 25%), rgba(0,0,0,.22) 65%, rgba(0,0,0,0) 66%),
        linear-gradient(140deg, rgba(0,0,0,0) -58%, rgba(0,0,0,calc(var(--private-card-card-k) * .5))),
        url('/local/templates/redesign/src/assets/img/private/card/card.png');
    mask-position: center;
    mask-repeat: no-repeat;
    mask-size: contain;
    mask-image: url('/local/templates/redesign/src/assets/img/private/card/card.png');

}
</style>
